export default [
    {
        path: "/rujukan",
        name: "rujukan",
        component: () => import("@/pages/rujukan/Rujukan.vue"),
        meta: {
            pageTitle: "Rujukan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            // resource: "pelatihan",
            action: "read",
        },
    },
];
